<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.adyen_settings.form.api_key')"
            :is-required="true"
            :error="errorsData.api_key"
            :hint="__('settings.adyen_settings.form.api_key_hint')"
        >
            <DInput
                id="api_key"
                v-model="form.api_key"
                :placeholder="__('settings.adyen_settings.form.api_key')"
                :is-valid="isFormFieldValid('api_key')"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.adyen_settings.form.environment')"
            :is-required="true"
            :error="errorsData.environment"
            :hint="__('settings.adyen_settings.form.environment_hint')"
        >
            <DSelect
                id="environment"
                v-model="form.environment"
                :options="environmentOptions"
                :placeholder="__('settings.adyen_settings.form.environment')"
                :is-valid="isFormFieldValid('environment')"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.adyen_settings.form.prefix')"
            :error="errorsData.prefix"
            :hint="__('settings.adyen_settings.form.prefix_hint')"
        >
            <DInput
                id="prefix"
                v-model="form.prefix"
                :placeholder="__('settings.adyen_settings.form.prefix')"
                :is-valid="isFormFieldValid('prefix')"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.adyen_settings.form.timeout')"
            :is-required="true"
            :error="errorsData.timeout"
            :hint="__('settings.adyen_settings.form.timeout_hint')"
        >
            <DInput
                id="timeout"
                v-model="form.timeout"
                :placeholder="__('settings.adyen_settings.form.timeout')"
                :is-valid="isFormFieldValid('timeout')"
                type="number"
                max="2147483647"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.adyen_settings.form.merchant_account')"
            :is-requird="true"
            :error="errorsData.merchant_account"
            :hint="__('settings.adyen_settings.form.merchant_account_hint')"
        >
            <DInput
                id="merchant_account"
                v-model="form.merchant_account"
                :placeholder="__('settings.adyen_settings.form.merchant_account')"
                :is-valid="isFormFieldValid('merchant_account')"
                maxlength="255"
            />
        </DFormRow>
        <DRow>
            <DCol sm="4" />
            <DCol sm="4">
                <div
                    v-if="connectionStatus === 'successful'"
                    class="connection-successful"
                >
                    {{ __('settings.adyen_settings.connection_successful') }}
                </div>
                <div
                    v-if="connectionStatus === 'unsuccessful'"
                    class="connection-failed"
                >
                    {{ __('settings.adyen_settings.connection_unsuccessful') }}
                </div>
            </DCol>
            <DCol
                sm="4"
                class="check-database-connection-btn"
            >
                <DButton
                    icon="lan-connect"
                    :label="__('settings.adyen_settings.check_connection')"
                    :disabled="isInLoadingState"
                    @click="checkConnection"
                />
            </DCol>
        </DRow>
        <DFormControls
            v-show="credentialsValid"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
        <DConnectionErrorModal
            :show-modal="connectionException !== null"
            :exception="connectionException"
            @close-modal="closeErrorCheckModal"
        />
    </DForm>
</template>

<script>

import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal'

export default {
    name: 'AdyenSettingsForm',
    components: { DConnectionErrorModal },
    props: {
        adyenSettings: {
            type: Object,
            default: () => { return {} }
        },
        environments: {
            type: Array,
            default () {
                return []
            }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                api_key: this.adyenSettings?.api_key ?? null,
                environment: this.adyenSettings?.environment ?? null,
                prefix: this.adyenSettings?.prefix ?? null,
                timeout: this.adyenSettings?.timeout ?? null,
                merchant_account: this.adyenSettings?.merchant_account ?? null
            }),
            connectionStatus: '',
            credentialsValid: false,
            errorsData: this.errors,
            connectionException: null
        }
    },
    computed: {
        environmentOptions () {
            return this.environments.map((environment) => {
                return {
                    label: environment,
                    value: environment
                }
            })
        }
    },
    watch: {
        form: {
            handler: function () {
                this.connectionStatus = ''
                this.credentialsValid = false
            },
            deep: true
        }
    },
    methods: {
        submitForm () {
            this.$emit('form-submitted', this.form)
        },
        checkConnection () {
            this.errorsData = {}
            const self = this
            self.connectionException = null
            window.axios.post(this.$route('settings.adyen-settings.check', this.form))
                .then(function () {
                    self.connectionStatus = 'successful'
                    self.credentialsValid = true
                })
                .catch(function (error) {
                    self.connectionStatus = 'unsuccessful'
                    self.credentialsValid = false
                    if (error.response.data.errors !== undefined) {
                        self.errorsData = error.response.data.errors

                        for (const key in self.errorsData) {
                            if (typeof self.errorsData[key] === 'object') {
                                self.errorsData[key] = self.errorsData[key][0]
                            }
                        }
                    }

                    if (error?.response.data.exception !== undefined) {
                        self.connectionException = error?.response.data.exception
                    }
                })
        },
        closeErrorCheckModal () {
            this.connectionException = null
        }
    }
}
</script>

<style scoped>
.check-database-connection-btn {
    text-align: right;
    padding-bottom: 25px;
}
.connection-successful {
    color: green;
}
.connection-failed {
    color: red;
}
</style>
